import Tooltip from "@material-ui/core/Tooltip";
import { styled } from "@material-ui/core/styles";
import Colors from "../../../utils/Colors";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} placement="bottom-start" />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: Colors.CULTURED,
    color: Colors.BLACK,
    maxWidth: 400,
    fontSize: theme.typography.pxToRem(13),
    border: "1px solid " + Colors.SILVER_SAND,
  },
}));

export default HtmlTooltip;
